import {
  Bot,
  BriefcaseBusiness,
  CloudCog,
  Code2,
  GitBranch,
  type LucideIcon,
  Rocket,
} from 'lucide-react';

import { Container } from '../components/Container';
import { SectionHeading } from '../components/SectionHeading';
import type { LandingContent } from '../content/types';
import { sectionIds } from '../lib/routes';

type ServicesSectionProps = {
  content: LandingContent;
};

const serviceIcons: Record<string, LucideIcon> = {
  launch: Rocket,
  saas: Code2,
  architecture: GitBranch,
  ai: Bot,
  cloud: CloudCog,
  consulting: BriefcaseBusiness,
};

export function ServicesSection({ content }: ServicesSectionProps) {
  return (
    <section className="section" id={sectionIds.services} aria-labelledby="services-title">
      <Container>
        <SectionHeading
          id="services-title"
          eyebrow={content.services.eyebrow}
          title={content.services.h2}
          intro={content.services.intro}
        />
        <div className="card-grid card-grid--services">
          {content.services.items.map((service) => {
            const Icon = serviceIcons[service.id] ?? Code2;

            return (
              <article className="service-card" key={service.id}>
                <div className="card-icon" aria-hidden="true">
                  <Icon size={24} />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-card__deliverables">
                  <h4>{content.common.deliverables}</h4>
                  <ul>
                    {service.deliverables.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
